<template>
    <b-row class="footer pmis-container">
        <b-col align="center" lg="2" md="4" class="footer-logo">
            <b-img fluid src="pic/logos/srip-pmis.png" class="footer-logo-pic"></b-img>
        </b-col>
        <b-col align="center" lg="4" md="8" class="footer-logo">
            <b-img fluid src="pic/logos/eu-mgrt.png" class="footer-logo-pic"></b-img>
        </b-col>
        <b-col align="center" lg="3" md="6" class="footer-logo">
            <b-img fluid src="pic/logos/ijs.png" class="footer-logo-pic f-add-padding"></b-img>
        </b-col>
        <b-col align="center" lg="3" md="6" class="footer-logo">
            <b-img fluid src="pic/logos/gzs.png" class="footer-logo-pic f-add-padding"></b-img>
        </b-col>
    </b-row>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style lang="scss" scoped>
    .footer {
        background-color: $footer-background;
    }
    .footer-logo {
        margin: 40px 0px;
    }
    .footer-logo-pic {
        height: 100px;
    }
    .f-add-padding {
        padding: 15px;
    }

    @media (max-width: 767px) {
      .footer-logo-pic {
        height: 125px;
      }
      .footer-logo {
        margin: 20px 0px;
      }
    }

</style>
